import { createFileRoute } from '@tanstack/react-router'

import ContactDetail from '@/routes/arc/contact/-ContactDetail.tsx'

export const Route = createFileRoute('/arc/contact/$id')({
  component: ContactPage,
})

function ContactPage() {
  const { id } = Route.useParams()

  return <ContactDetail id={id} hasBack={true} />
}
